<template>
  <div class="text-xs-center">
    <v-btn
      :disabled="dialog"
      :loading="dialog"
      class="white--text"
      color="purple darken-2"
      @click.stop="dialog = true"
    >
      Start loading
    </v-btn>
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import store from '.././store'
  export default {
    name: 'my-loader',

    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.$store.commit('setLoader', false)), 4000)
      }
    },

    computed: {
        loading() {
            return this.$store.getters.loader
        }
    }
  }
</script>